import script from "./CreateArtikel.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateArtikel.vue?vue&type=script&setup=true&lang=js"

import "./CreateArtikel.vue?vue&type=style&index=0&id=37171b94&lang=css"

const __exports__ = script;

export default __exports__